exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-TextAreaInput-input{line-height:1 !important;border:3px solid #929292 !important;border-radius:0 !important;background-color:#fcfcfc !important;background-image:none !important}.src-components-shared-TextAreaInput-input:disabled{line-height:1 !important;border:3px solid #b3b3b3 !important;border-radius:0 !important;background-color:#e6e6e6 !important}", ""]);

// exports
exports.locals = {
	"input": "src-components-shared-TextAreaInput-input"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/TextAreaInput/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/TextAreaInput/styles.scss
// module chunks = 1